import { render } from "./ForgotPassword.vue?vue&type=template&id=66f47cb6"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script